import { get } from '../base';
import { Permission } from '../../../states/ducks/permissions/types';

/**
 * @return {Promise<Permission[]>}
 */
export const listPermissions = async (): Promise<Permission[]> =>
  await get(`/v1/iam/permissions/list/intwi`);
